import type { AppState } from 'types/app';

export const selectSizingChooser = (state: AppState) => state.sizingChooser;

export const selectOnDemandSizing = (state: AppState) => selectSizingChooser(state).onDemandSizing;

export const selectDemandPredictedSize = (state: AppState) => selectOnDemandSizing(state).predictedSize;

export const selectRecommendedFit = (state: AppState) => selectSizingChooser(state).sizingChooser.recommendedFit;
